export default __webpack_public_path__ + "static/media/the_opportunity_xl.7ab8ae5f.jpg";